import React from "react";
import { FormContext, FormContextType } from "../form-provider";

export const useFormState = (): FormContextType => {
  return React.useContext(FormContext);
};
